module.exports = __webpack_public_path__ + "static/media/highTeachIco1 .bb402250.png";